<template>
  <div class="num-counter">
    <!-- 兼容ios 双击放大问题，改成背景图样式 -->
    <span :class=" leftDisabled ? 'symbol del-symbol disdel-symbol': 'symbol del-symbol'" @click="minus">
      <!-- <img v-if="!leftDisabled" src="./imgs/h5_sub@2x.png" />
      <img v-if="leftDisabled" src="./imgs/h5_grey_sub@2x.png" /> -->
    </span>
    <input
      type="number"
      v-model="numCounter"
      :readonly="inputDisable"
      class="num"
      @click="inputClick"
    />
    <span :class="rightDisabled ? 'symbol add-symbol disadd-symbol': 'symbol add-symbol'" @click="add">
      <!-- <img v-if="!rightDisabled" src="./imgs/h5_add@2x.png" />
      <img v-if="rightDisabled" src="./imgs/h5_grey_add@2x.png" /> -->
    </span>
  </div>
</template>

<script>
export default {
  name: 'numCounter',

  data() {
    return {
      // numCounter: 1,
      // rightDisabled: false,
      // leftDisabled: false
    };
  },
  methods: {
    add() {
      this.$emit('add');
    },
    minus() {
      this.$emit('minus');
    },

    inputClick() {
      this.$emit('inputClick', this.numCounter);
    }

  },
  props: {
    numCounter: {
      type: Number,
      default: () => {
        return 1;
      }
    },
    inputDisable: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      default: 10000
    },
  },
  mounted() {
  },
  computed: {
    rightDisabled() {
      return this.numCounter >= this.max ? true : false;
    },
    leftDisabled() {
      return this.numCounter <= this.min ? true : false;
    }
  }
};
</script>

<style scoped lang="stylus">
.num-counter {
  width: 116px;
  height: 32px;
  border: 1px solid #F2F2F2;
  display: flex;
  border-radius 4px;
  overflow hidden
  background #fff

  span {
    display inline-block
    width 40px
    img {
      width 100%
      height 100%
    }
  }

  .num {
    width: 52px;
    height: 100%;
    border none
    border-left 1px solid #F2F2F2
    border-right 1px solid #F2F2F2
    text-align center
    border-radius 0
  }

  .symbol {
    flex: 1;
    font-weight: bold;
  }
  .del-symbol {
    background: url('https://coolcdn.igetcool.com/p/2023/12/68dc3c68b91f38ae56cd5abedb4946ed.png?_58x56.png')
    background-size: 32px 32px
  }
  .disdel-symbol {
    background: url('https://coolcdn.igetcool.com/p/2023/12/37dca82505de40307b9ffdaabf06cb35.png?_58x56.png')
    background-size: 32px 32px
  }
  .add-symbol {
    background: url('https://coolcdn.igetcool.com/p/2023/12/76157cc71a5980babc53ca7302d8fa5c.png?_58x56.png')
    background-size: 32px 32px
  }
  .disadd-symbol {
    background: url('https://coolcdn.igetcool.com/p/2023/12/dbeef4e3f5669ede30ed857f129ca577.png?_58x56.png')
    background-size: 32px 32px
  }


}


@media screen and (-webkit-min-device-pixel-ratio:0)
  span, input,
  img {
    font-size: 16px;
  }

</style>
